/*global Materialize*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component }   from 'react';
import { connect }            from 'react-redux';
import validator              from 'validator';
import {fetch}                from '@fyresite/fetch';
import { permissions } from '../../../constants.js';
import Button from '../../../components/Button'
import TextInput from '@fyresite/react-textinput';

class AddUser extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      email: {
        valid: '',
        value: '',
        error: "Please Add a valid Email"
      },
      firstName: {
        valid: '',
        value: '',
        error: "Please add a first name"
      },
      lastName: {
        valid: '',
        value: '',
        error: "Please add a last name"
      },
      password: {
        valid: '',
        value: '',
        error: "Please add a valid password"
      },
      password_confirm: {
        valid: '',
        value: '',
        error: "Please add confirm password"
      },
      permissions: {
        valid: '',
        value: '',
        error: "Please add permissions"
      }
    };
    this.handleInputKeyPress = this.handleInputKeyPress.bind(this)
  }


  componentWillUnmount(){
    document.removeEventListener("keydown", this.handleInputKeyPress);
  }
  componentWillMount(){
    if(this.props.user.permissions < 5){
      this.props.history.push('/dashboard');
    } else {
      document.addEventListener("keydown", this.handleInputKeyPress);
    }
  }
  handleInputKeyPress(e){
    if(e.key && e.key.toLowerCase() === 'enter'){
      this.handleSubmit(e);
    }
  }

  onChange(field, e, inputState) {
    let state = Object.assign({}, this.state);

		state[field] = Object.assign({}, state[field], inputState);

    this.setState((prevState, props) => {
      return state;
    });
  }

  onRadioChange(field, e){
    let value = e.target.value;
    let stateField = this.state[field];

    stateField.value = value;
    stateField.valid = true;

    this.setState((prevState, props) => {
      return {
        [field]: stateField
      }
    })
  }

  handleSubmit(e) {
    e.preventDefault();

    for(var x = 0; x < Object.keys(this.state).length; x++){
      let key = Object.keys(this.state)[x];
      if(!this.state[key].valid){
        alert(this.state[key].error);
        return;
      }
    }

    fetch('/api/v1/user/create', {
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: this.state.email.value,
        firstName: this.state.firstName.value,
        lastName: this.state.lastName.value,
        password: this.state.password.value,
        permissions: this.state.permissions.value,
        activated: true
      })
    }).then(res => {
      return res.json();
    }).then(json => {
      if(json.code === 200){
        Materialize.toast(`Success, ${json.message}`, 4000, 'green');
        this.props.history.push('/dashboard/list-users')
      } else {
        Materialize.toast(`Error occurred, ${json.message}`, 4000, 'red');
      }
    }).catch(err => {
      Materialize.toast(`Error occurred, ${err}`, 4000, 'red');
    });
  }

  render() {
    return (
      <div className="add-user">
        <div className="add-user-inner">
          <h4>Add User</h4>
          <div className="card-wrapper">
            <div className="card-container">
              <div className="form-card card z-depth-5" ref="form-card">
                <div className="card-content">
                  <span className="card-title">{this.props.title}</span>
                  <form onSubmit={this.handleSubmit.bind(this)} className="left-align" noValidate>
                    <TextInput 
                      ref={input => this.email = input}
                      className=""
                      inputClassName=""
                      id='email'
                      label='Email Address'
                      error='Please enter a valid email address'
                      type='email'
                      onChange={this.onChange.bind(this, "email")}
                      value={this.state.email.value}
                      valid={this.state.email.valid}
                      validator={val => { return validator.isEmail(val) }} />
                    <TextInput 
                      ref={input => this.firstName = input}
                      className=""
                      inputClassName=""
                      id='firstName'
                      label='First Name'
                      error='Please enter a first name'
                      type='text'
                      onChange={this.onChange.bind(this, "firstName")}
                      value={this.state.firstName.value}
                      valid={this.state.firstName.valid}
                      validator={val => { return val.length > 1 }} />
                    <TextInput 
                      ref={input => this.lastName = input}
                      className=""
                      inputClassName=""
                      id='lastName'
                      label='Last Name'
                      error='Please enter a last name'
                      type='text'
                      onChange={this.onChange.bind(this, "lastName")}
                      valid={this.state.lastName.valid}
                      value={this.state.lastName.value}
                      validator={val => { return val.length > 1 }} />
                    <div>
                      <label>{"Permissions"}</label>
                      <div className="radios">
                        {
                          Object.keys(permissions).map((key,index) => {
                            let value = permissions[key];

                            return (
                              <div key={`${value}-${index}`}>
                                <input
                                  type="radio"
                                  id={`permissions-${value}`}
                                  checked={parseInt(value,10) === parseInt(this.state.permissions.value, 10)}
                                  value={value}
                                  onChange={this.onRadioChange.bind(this, "permissions")} />
                                <label htmlFor={`permissions-${value}`}>{key}</label>
                              </div>
                            );
                          })
                        }
                      </div>
                    </div>
                    <TextInput 
                      ref={input => this.password = input}
                      className=""
                      inputClassName=""
                      label="Password"
                      type="password"
                      onChange={this.onChange.bind(this, 'password')}
                      value={this.state.password.value}
                      valid={this.state.password.valid}
                      validator={val => { return validator.matches(val, /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,15}$/) }}
                      error="Password must be at least 4 characters, no more than 15 characters, and must include at least one upper case letter, one lower case letter, and one numeric digit." />
                    <TextInput 
                      ref={input => this.password_confirm = input}
                      className=""
                      inputClassName=""
                      label="Confirm Password"
                      type="password"
                      onChange={this.onChange.bind(this, 'password_confirm')}
                      value={this.state.password_confirm.value}
                      valid={this.state.password_confirm.valid}
                      validator={val => { return val === this.state.password.value }}
                      error="Must match the password field" />
                    <Button
                      color={'red'}
                      flat={false}
                      onClick={this.handleSubmit.bind(this)}
                      z-depth={1}>
                      {"Add User"}
                    </Button>
                    <Button
                      color={null}
                      flat={true}
                      onClick={e => this.props.history.push('/dashboard/list-users')}
                      z-depth={1}>
                      {"Back"}
                    </Button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(AddUser);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/AddUser/AddUser.js